var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEditOutline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-edit-outline",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160728",
    "data-name": "Group 160728"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4469",
    "data-name": "Path 4469",
    d: "M16.945,1.055a3.6,3.6,0,0,0-5.093,0L1.787,11.12a.7.7,0,0,0-.18.309L.026,17.108a.7.7,0,0,0,.869.865l5.68-1.613a.7.7,0,0,0,.306-1.173L3.3,11.6l8.343-8.343,3.1,3.1-6.387,6.37a.7.7,0,0,0,.993,1l7.593-7.572a3.6,3.6,0,0,0,0-5.093ZM5.041,15.334l-3.325.944.931-3.345ZM15.952,5.153l-.21.209-3.1-3.1.209-.209a2.2,2.2,0,0,1,3.105,3.1Z",
    transform: "translate(0)",
    fill: "#707070"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEditOutline);
export default __webpack_public_path__ + "static/media/ic-edit-outline.fc3b87cb3607d3b05dc5d38329b59a1b.svg";
export { ForwardRef as ReactComponent };